export enum SortType {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export enum TransactionType {
  ELECTRICITY_COSTS = 'Electricity cost',
  TOP_UP = 'Top up',
  BTC_EARNINGS = 'Bitcoin earnings',
  BTC_PAYOUTS = 'Bitcoin payouts',
}

export enum ApiTransactionType {
  ELECTRICITY_COSTS = 'Electricity cost',
  TOP_UP = 'Top up',
  BTC_EARNINGS = 'Bitcoin earnings',
  BTC_PAYOUTS = 'Bitcoin payouts',
}

export enum ApiTransactionStatus {
  PAID = 'Paid',
  OPEN = 'Open',
}
